import React, { useState, useEffect } from "react";
import examQuestions from "../data/examQuestions";
import Timer from "./Timer";
import Results from "./Results";
import { WithBackButton } from "./WithBackButton";

// Funkcja do tasowania odpowiedzi
const shuffleAnswers = (answers) => {
  const entries = Object.entries(answers);
  for (let i = entries.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [entries[i], entries[j]] = [entries[j], entries[i]];
  }
  return Object.fromEntries(entries);
};

// Funkcja do losowania unikalnych pytań
const getShuffledExamSet = (questions, total) => {
  const shuffled = [...questions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, total);
};

const Exam = () => {
  const totalQuestions = 20;
  const [examSet, setExamSet] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [shuffledAnswers, setShuffledAnswers] = useState({});
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [examCompleted, setExamCompleted] = useState(false);
  const [examStartTime, setExamStartTime] = useState(null);
  const [timeTaken, setTimeTaken] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const selectedQuestions = getShuffledExamSet(examQuestions, totalQuestions);
    setExamSet(selectedQuestions);
    setShuffledAnswers(shuffleAnswers(selectedQuestions[0].answers));
    setExamStartTime(Date.now());
  }, []);

  const currentQuestion = examSet[currentQuestionIndex];

  const handleAnswerClick = (answerKey) => {
    setSelectedAnswer(answerKey);
  };

  const nextQuestion = () => {
    setUserAnswers((prev) => [
      ...prev,
      { questionId: currentQuestion.id, answer: selectedAnswer },
    ]);
    setSelectedAnswer(null);

    if (currentQuestionIndex + 1 >= totalQuestions) {
      const elapsed = (Date.now() - examStartTime) / 1000;
      setTimeTaken(elapsed);
      setExamCompleted(true);
    } else {
      const nextIndex = currentQuestionIndex + 1;
      setCurrentQuestionIndex(nextIndex);
      setShuffledAnswers(shuffleAnswers(examSet[nextIndex].answers));
    }
  };

  const togglePause = () => {
    setIsPaused((prev) => !prev);
  };

  const onTimeUp = () => {
    const elapsed = (Date.now() - examStartTime) / 1000;
    setTimeTaken(elapsed);
    setExamCompleted(true);
  };

  if (examCompleted) {
    return (
      <Results
        userAnswers={userAnswers}
        examQuestions={examSet}
        timeTaken={timeTaken}
      />
    );
  }

  return (
    <div className="exam">
      <Timer initialTime={1800} onTimeUp={onTimeUp} isPaused={isPaused} />
      <div className="exam__container">
        <h2 className="exam__question-count">
          Pytanie {currentQuestionIndex + 1}/{totalQuestions}
        </h2>
        {currentQuestion && (
          <>
            <h2 className="exam__question">{currentQuestion.question}</h2>
            <ul className="exam__answers">
              {Object.entries(shuffledAnswers).map(([key, answer]) => (
                <li key={key} className="exam__answer-item">
                  <button
                    className={`exam__answer-button ${
                      selectedAnswer === key ? "selected" : ""
                    }`}
                    onClick={() => handleAnswerClick(key)}
                  >
                    {key.toUpperCase()}. {answer}
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}
        {selectedAnswer && (
          <button className="exam__next-button" onClick={nextQuestion}>
            Następne pytanie
          </button>
        )}
        <div className="exam__control-buttons">
          <button className="exam__pause-button" onClick={togglePause}>
            {isPaused ? "Wznów" : "Pauza"}
          </button>
          <WithBackButton className="exam__back-button" />
        </div>
      </div>
    </div>
  );
};

export default Exam;
